import {assign, createMachine} from "xstate";
import apiMethods from "@/js/api/apiMethods";
import { AuthState } from "./auth.machine";
import { periodsList, typeList } from "@/js/constants";

export const distrStatMachine = createMachine({
    id: "owner-stat",
    initial: "loadingShopData",
    type: "parallel",
    context: {
        type: typeList[0], // price, liters
        period: periodsList[0], // month, 3months, 6months, year
        chart_data: [],
        good: "",
        date: "",
        goods: [],
        shops: [],
        points: [],
        pointsList: [],
        owners: [],
        ownersList: [],
        meta: {},
        current_shop: 0,
        current_page: 1,
        pages: undefined,
        list: [],
        id: "",
        errorMsg: []
    },
    states: {
        goods: {
            initial: "loading",
            states: {
                loading: {
                invoke: {
                    id: "getGoodsData",
                    src: "getGoodsData",
                },
                on: {
                    DONE_GOOD: {
                        actions: "saveGoodsData",
                        target: "success",
                    },
                    ERROR_GOOD: {
                        target: "failure",
                        actions: ["saveError"],
                    },
                },
            },
                success: {},
                failure: {},
            },
        },
        points: {
            initial: "loading",
            states: {
                loading: {
                invoke: {
                    id: "getPointsData",
                    src: "getPointsData",
                },
                on: {
                    DONE_POINTS: {
                        actions: "savePointsData",
                        target: "success",
                    },
                    ERROR_POINTS: {
                        target: "failure",
                        actions: ["saveError"],
                    },
                },
            },
                success: {},
                failure: {},
            },
        },
        owners: {
            initial: "loading",
            states: {
                loading: {
                invoke: {
                    id: "getOwnersData",
                    src: "getOwnersData",
                },
                on: {
                    DONE_OWNERS: {
                        actions: "saveOwnersData",
                        target: "success",
                    },
                    ERROR_OWNERS: {
                        target: "failure",
                        actions: ["saveError"],
                    },
                },
            },
                success: {},
                failure: {},
            },
        },
        chart: {
            initial: "loading",
            states: {
                "loading": {
                    entry: "scrollTop",
                    invoke: {
                        id: "getChartData",
                        src: "getChartData"
                    },
                    on: {
                        "DONE_CHART": {
                            actions: ["saveChartData"],
                            target: "success"
                        },
                        "ERROR_CHART": {
                            actions: ["saveError"],
                            target: "failure"
                        }
                    }
                },
                "success": {
                    on: {
                        "CHANGE_FILTER": {
                            actions: ["saveChartData"],
                            target: "loading"
                        }
                    }
                },
                "failure": {}
            }
        },
        table: {
            initial: "loading",
            states: {
                "loading": {
                    invoke: {
                        id: "getTableData",
                        src: "getTableData"
                    },
                    on: {
                        "DONE_TABLE": {
                            target: "success",
                            actions: ["saveTableData"]
                        },
                        "ERROR_TABLE": {
                            target: "failure",
                            actions: ["saveError"]
                        }
                    }
                },
                "success": {
                    on: {
                        "prevPage": {
                            actions: ["changePage"],
                            target: "loading",
                            cond: "isntFirstPage"
                        },
                        "nextPage": {
                            actions: ["changePage"],
                            target: "loading",
                            cond: "isntLastPage"
                        },
                    }
                },
                "failure": {}
            }
        },
    }
}, {
    actions: {
        "saveChartData": assign({
            "period": (ctx, message) =>
                message.data.period !== undefined ? message.data.period : ctx.period,
            "date": (ctx, message) =>
                message.data.date !== undefined ? message.data.date : ctx.date,
            "type": (ctx, message) =>
                message.data.type !== undefined ? message.data.type : ctx.type,
            "good": (ctx, message) =>
                message.data.good !== undefined ? message.data.good : ctx.good,
            "points": (ctx, message) =>  message.data.points ?? ctx.points,
            "owners": (ctx, message) =>  message.data.owners ?? ctx.owners,
            "chart_data": (ctx, message) => message.data,
            "current_shop": (ctx, message)=> message.data.shop ?? ctx.current_shop
        }),
        "saveTableData": assign({
            list: (ctx, message) => message.data.data.data,
            meta: (ctx, message) => message.data.data.meta,
            current_page: (ctx, message) => message.data.data.meta.currentPage,
            pages: (ctx, message) => message.data.data.meta.lastPage,
        }),
        "savePointsData": assign({
            pointsList: (ctx, message) => message.data,
        }),
        "saveOwnersData": assign({
            ownersList: (ctx, message) => message.data,
        }),
        "changePage": assign({
            "current_page": (ctx, message) => {
                return message.type === "nextPage" ? ctx.current_page + 1 : ctx.current_page - 1
            }
        }),
        "saveGoodsData": assign({
            goods: (ctx, message) => message.data,
        }),
        "scrollTop": () => {
            window.scrollTo(0, 0);
        },
        "saveError": assign({
            "errorMsg": (ctx, message) => message.data
        })
    },
    services: {
        "getChartData": (ctx) => {
            return async function (send) {
                try {
                    const userType = AuthState._state.context.type;
                    const response = await apiMethods.statistics.getData(userType, {
                        period: ctx.period.value,
                        type: ctx.type.value,
                        good: ctx.good.value,
                        ...(ctx?.date ? { date: ctx.date }: {}),
                        ...(ctx.points ? {points: ctx.points.map(item => item.value)} : {}),
                        ...(ctx.sellers ? {sellers: ctx.sellers.map(item => item.value)} : {})
                    });
                    
                    if (response.status === 200) {
                        send({
                            type: "DONE_CHART",
                            data: response.data.data,
                        });
                    }
                } catch (err) {
                    send({
                        type: "ERROR_CHART",
                        data: err.response.data.message,
                    });
                }
            }
        },
        "getTableData": (ctx) => {
            return async function (send) {
                await apiMethods.sales
                .getDistSales(10, ctx.current_page)
                .then((response) => {
                    send({
                        type: "DONE_TABLE",
                        data: response,
                    });
                })
                .catch((e) => {
                    send({
                        type: "ERROR_TABLE",
                        data: err.response.data.message,
                    });
                });
            }
        },
        getGoodsData: (ctx) => {
            return async function (send) {
                try {
                    const response = await apiMethods.statistics.getGoods();
                    
                    if (response.status === 200) {
                        send({
                            type: "DONE_GOOD",
                            data: response.data.data,
                        });
                    }
                } catch (err) {
                    send({
                        type: "ERROR_GOOD",
                        data: err.response.data.message,
                    });
                }
            };
        },
        getPointsData: (ctx) => {
            return async function (send) {
                try {
                    const response = await apiMethods.salePoints.getSalePoints();
                    if (response.status === 200) {
                        send({
                            type: "DONE_POINTS",
                            data: response.data.data,
                        });
                    }
                } catch (err) {
                    send({
                        type: "ERROR_POINTS",
                        data: err.response.data.message,
                    });
                }
            };
        },
        getOwnersData: (ctx) => {
            return async function (send) {
                try {
                    const response = await apiMethods.owners.getData({
                        limit: 9999
                    });
                    
                    if (response.status === 200) {
                        send({
                            type: "DONE_OWNERS",
                            data: response.data.data,
                        });
                    }
                } catch (err) {
                    send({
                        type: "ERROR_OWNERS",
                        data: err.response.data.message,
                    });
                }
            };
        },
    },
    "guards": {
        "isntFirstPage": (ctx, message) => ctx.current_page !== 1,
        "isntLastPage": (ctx, message) => ctx.current_page !== ctx.pages,
    }
});